import { createId } from '@paralleldrive/cuid2';
import { localStorage } from 'dibs-browser-storage';
import { cookieJarConstants, getBuyerId } from 'dibs-cookie-jar';
import Cookies from 'js-cookie';

// As of Apple ITP 2.1, guestIds are stored in localStorage
// See: https://1stdibs.atlassian.net/browse/ENGAGE-979
const getGuestIdFromLocalStorage = (): string => {
    const guestId = localStorage.getItem(cookieJarConstants.GUEST_ID);
    return typeof guestId === 'string' ? guestId : '';
};

const getGuestIdFromCookie = (): string => {
    const guestId = Cookies.get(cookieJarConstants.GUEST_ID);
    return typeof guestId === 'string' ? guestId : '';
};

export const getGuestId = (): string => {
    return getGuestIdFromCookie() || getGuestIdFromLocalStorage();
};

export const handleGuestId = (): void => {
    if (!getBuyerId(document.cookie)) {
        let guestIdFromLocalStorage = getGuestIdFromLocalStorage();
        const guestIdFromCookie = getGuestIdFromCookie();
        if (!guestIdFromLocalStorage) {
            guestIdFromLocalStorage = createId();
            localStorage.setItem(cookieJarConstants.GUEST_ID, guestIdFromLocalStorage);
        }
        if (!guestIdFromCookie) {
            Cookies.set(cookieJarConstants.GUEST_ID, guestIdFromLocalStorage);
        }
    }
};
